import React from 'react';
import { LoadingSpinner, EmptyState, StatusBadge } from './shared';

const formatSEK = (n) => (n || 0).toLocaleString('sv-SE') + ' kr';

export const OrdersSection = ({ orders, loading }) => (
  <div className="space-y-4" data-testid="admin-orders">
    {loading ? <LoadingSpinner /> : orders.length > 0 ? (
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50/80 border-b border-gray-100">
                <th className="text-left p-4 font-semibold text-gray-600">Order</th>
                <th className="text-left p-4 font-semibold text-gray-600 hidden md:table-cell">Kund</th>
                <th className="text-left p-4 font-semibold text-gray-600 hidden lg:table-cell">Datum</th>
                <th className="text-right p-4 font-semibold text-gray-600">Belopp</th>
                <th className="text-right p-4 font-semibold text-gray-600 hidden md:table-cell">Provision</th>
                <th className="text-left p-4 font-semibold text-gray-600">Status</th>
              </tr>
            </thead>
            <tbody>
              {orders.slice(0, 30).map((order) => (
                <tr key={order.id} className="border-b border-gray-50 hover:bg-blue-50/30 transition-colors" data-testid={`order-row-${order.id}`}>
                  <td className="p-4">
                    <span className="font-mono text-xs font-semibold text-[#003B73] bg-blue-50 px-2 py-1 rounded">
                      {(order.order_number || order.id?.slice(0, 8)).toUpperCase()}
                    </span>
                  </td>
                  <td className="p-4 hidden md:table-cell">
                    <span className="text-gray-700">{order.buyer?.name || order.buyer?.email || '—'}</span>
                  </td>
                  <td className="p-4 text-gray-500 hidden lg:table-cell">{new Date(order.created_at).toLocaleDateString('sv-SE')}</td>
                  <td className="p-4 text-right font-semibold text-gray-900">{formatSEK(order.grand_total)}</td>
                  <td className="p-4 text-right hidden md:table-cell">
                    <span className="text-xs font-semibold text-emerald-600 bg-emerald-50 px-2 py-1 rounded">
                      {formatSEK(order.commission_amount)}
                    </span>
                  </td>
                  <td className="p-4"><StatusBadge status={order.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    ) : <EmptyState message="Inga ordrar" />}
  </div>
);
